import { render, staticRenderFns } from "./relCostView.vue?vue&type=template&id=76e36b18"
import script from "./relCostView.vue?vue&type=script&lang=js"
export * from "./relCostView.vue?vue&type=script&lang=js"
import style0 from "./relCostView.vue?vue&type=style&index=0&id=76e36b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports